import { Box, Typography, Container, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { Code } from "@mui/icons-material";
import StorageIcon from "@mui/icons-material/Storage";
import PreviewIcon from "@mui/icons-material/Preview";

const skills = [
  { name: "Python", icon: <Code /> },
  { name: "Java", icon: <Code /> },
  { name: "Laravel", icon: <Code /> },
  { name: "PHP", icon: <Code /> },
  { name: "MySql", icon: <Code /> },
  { name: "JavaScript", icon: <Code /> },
  { name: "Node.js", icon: <Code /> },
  { name: "Express.js", icon: <Code /> },
  { name: "MongoDB", icon: <StorageIcon /> },
  { name: "React", icon: <PreviewIcon /> },
];

const Skills = () => {
  return (
    <Box id="skills" sx={{ py: 8, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            align="center"
            sx={{ mb: 6 }}
          >
            Technical Skills
          </Typography>

          <Grid container spacing={4}>
            {skills.map((skill, index) => (
              <Grid item xs={12} sm={6} key={skill.name}>
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box sx={{ mr: 2, color: "primary.main" }}>
                      {skill.icon}
                    </Box>
                    <Typography variant="h6">{skill.name}</Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Skills;
